import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from "@mui/material";
import StyledDialogTitle from "../../../../common/components/dialog/dialog-title";
import { Handlers } from "../../api/handlers";

import { CheckCircle } from "@mui/icons-material";
import useUserManagementStore from "../../api/store";

const CredentialsSentDialog: React.FC = () => {
  const handlers = new Handlers();

  const { isUserCredentialsSent, activeUser } = useUserManagementStore();

  return (
    <Dialog
      open={isUserCredentialsSent}
      onClose={handlers.handleCloseCredentialsSent}
      slotProps={{
        paper: {
          component: "form",
          sx: { borderRadius: "24px" },
        },
      }}
      maxWidth={"laptop"}
      fullWidth
      keepMounted
      aria-describedby="confirm-password-dialog"
    >
      <StyledDialogTitle
        title="User Credentials Successfully Sent"
        actionType="close"
        handleClose={handlers.handleCloseCredentialsSent}
      />

      <DialogContent sx={{ minWidth: "300px" }}>
        <Box
          sx={{
            width: "100%",
            padding: "10px",
            display: "flex",
            flexDirection: "column",

            gap: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <CheckCircle
              sx={{ color: "#1CA568", width: "20px", height: "20px" }}
            />
            <Typography>
              User credentials have been updated and sent to their registered
              email address{" "}
              <Typography component="span" sx={{ color: "red" }}>
                {activeUser?.email}
              </Typography>
              .
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ pr: 3, pb: 2 }}>
        <Button
          type="submit"
          variant="contained"
          onClick={handlers.handleCloseCredentialsSent}
          sx={{ backgroundColor: "#546A89", borderRadius: "12px" }}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CredentialsSentDialog;
